import { IntakeFormCustomQuestionAnswer } from 'types/IntakeForm';
import { Relationship } from 'types/MasterData';
import { Pet } from 'types/Pet';

export const emptyCustomer = (channel: string): Customer => ({
    id: undefined,
    name: '',
    lastName: '',
    email: '',
    phone: '',
    channel,

    active: true,
    blocked: false,

    pets: []
});

export interface Customer {
    id?: number;

    name: string;
    token?: string;
    lastName: string;

    email: string;
    phone: string;
    channel?: string;

    active: boolean;
    blocked: boolean;

    pets: Array<Pet>;
    addresses?: Array<CustomerAddress>;
    emergencyContacts?: Array<EmergencyContact>;
    answers?: Array<IntakeFormCustomQuestionAnswer>;
}

export enum CustomerChannel {
    ONLINE_BOOKING = 'online_booking',
    INTAKE_FORM = 'intake_form'
}

export interface CustomerAddress {
    city: string;
    state: string;
    zipCode: string;
    country: string;
    addressLineOne: string;
    addressLineTwo?: string;
    active: boolean;
}

export interface EmergencyContact {
    uuid: string;
    phone: string;
    name: string;
    lastName: string;
    relationship: Relationship;
}
